import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { NewPasswordPage } from '@/features/auth/new-password-page';

const searchSchema = z.object({
  /** The one-time link token from the email (FR-AUTH-14); never sent anywhere but the API. */
  token: z.string().max(128).optional().catch(undefined),
});

/**
 * Reset password from an emailed link (FR-AUTH-17, T-13A). Public and reachable while signed in:
 * saving ends every session of the account anyway.
 */
export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  return <NewPasswordPage purpose="reset" token={token ?? ''} />;
}
